import { render, staticRenderFns } from "./AccountWithdrawalView.vue?vue&type=template&id=a13f4cf4&"
import script from "./AccountWithdrawalView.vue?vue&type=script&lang=ts&"
export * from "./AccountWithdrawalView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports